import DividerImage from "static/divider.png";

export const homeDivider = {
    backgroundImage: `url(${DividerImage})`,
    backgroundSize: "100% 100%",
    height: "4vh"
}